<script>
import { useSharedStore } from "@/stores/shared-store";
import { useAccessClassRequestStore } from "@/stores/access/access-class-request-store";
import { Modal } from "bootstrap";

export default {
  data(){
    return{
      sharedStore: null,
      accessClassRequestStore: null,
    }
  },
  created() {
    this.sharedStore = useSharedStore()
    this.accessClassRequestStore = useAccessClassRequestStore()
  },

  methods:{
    submitApprove(){
      this.accessClassRequestStore.approveAccessRequest()

      const modalEl = document.getElementById("approveAccessModal");
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      modal.hide();
    }
  }
};
</script>
<template>
  <div class="modal fade" id="approveAccessModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Approve Request Access</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="isax isax-close-circle5"></i>
          </button>
        </div>
        <form @submit.prevent="submitApprove">
          <div class="modal-body">
            <label class="form-label"
              >Aditional Duration (Day)<span class="text-danger ms-1">*</span>
              <i
                class="isax isax-info-circle ms-1"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Berapa lama durasi tambahan yang di dapat student."
              ></i
            ></label>
            <input
              v-model="placeholder"

              class="form-control mb-2"
              placeholder="duration"
              type="number"
              min="0"
            />
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary mx-1"
              :disabled="false"
            >
              Submit
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
